import { ContentObjectTypes, useContentObjectType } from 'content-management-data-lib';
import useContentPlatformListingConfiguration from './useContentPlatformListingConfiguration';
const NEW_COLUMN_KEY_TO_LEGACY_COLUMN_KEY_MAP = {
  [`${ContentObjectTypes.BLOG_POST}_ListingCustomColumns`]: 'blogPostsFrameworkCustomColumns',
  [`${ContentObjectTypes.BLOG_LISTING_PAGE}_ListingCustomColumns`]: 'blogListingPagesFrameworkCustomColumns',
  [`${ContentObjectTypes.LANDING_PAGE}_ListingCustomColumns`]: 'landingPagesFrameworkCustomColumns',
  [`${ContentObjectTypes.SITE_PAGE}_ListingCustomColumns`]: 'sitePagesFrameworkCustomColumns'
};
const useTableColumnUserSettingsKeys = () => {
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    customTableColumnUserSettingsKey
  } = useContentPlatformListingConfiguration();
  const columnUserSettingsKey = customTableColumnUserSettingsKey || `${contentObjectType}_ListingCustomColumns`;
  const legacyColumnKey = NEW_COLUMN_KEY_TO_LEGACY_COLUMN_KEY_MAP[columnUserSettingsKey];
  return {
    columnUserSettingsKey,
    legacyColumnKey
  };
};
export default useTableColumnUserSettingsKeys;